import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export function getAvailableActions(
  actions:
    | IFtthOrchestrator["actions"]
    | IMobileOrchestrator["actions"]
    | IFSecureOrchestrator["actions"],
) {
  return Object.fromEntries(
    actions.map(({ rel }) => {
      return [rel, true];
    }),
  );
}
